import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import "./css/Newheader.css";
import { useDispatch } from "react-redux";
import { logout } from "../../auth/authSlice";
import QuizFaqs from "./QuizFaqs";

const Newheader = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logOut = () => {
    dispatch(logout());
    navigate("/home");
  };
  return (
    <nav className="dashboard-navbar">
      <div className="dashboard-nav-container">
        {/* Logo */}
        <div className="dashboard-nav-brand">
          <Link to="/quizhomepage" className="dashboard-brand-link">
            <img
              src="../images/docmasterLogo.png"
              alt="DocMaster Quiz Logo"
              className="dashboard-brand-logo"
            />
          </Link>
        </div>

        {/* Navigation Menu */}
        <ul className="dashboard-nav-menu" role="menubar" aria-label="Main">
          <li>
            <NavLink
              to="/QuizHomePage"
              className={({ isActive }) =>
                `dashboard-nav-link ${isActive ? "active" : ""}`
              }
            >
              Home
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/quiz-dashboard"
              className={({ isActive }) =>
                `dashboard-nav-link ${isActive ? "active" : ""}`
              }
            >
              Dashboard
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/quiz-syllabus"
              className={({ isActive }) =>
                `dashboard-nav-link ${isActive ? "active" : ""}`
              }
            >
              Syllabus
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/participate"
              className={({ isActive }) =>
                `dashboard-nav-link ${isActive ? "active" : ""}`
              }
            >
              How to Participate
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/testimonials"
              className={({ isActive }) =>
                `dashboard-nav-link ${isActive ? "active" : ""}`
              }
            >
              Testimonials
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/contact"
              className={({ isActive }) =>
                `dashboard-nav-link ${isActive ? "active" : ""}`
              }
            >
              Contact
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/aboutQuiz"
              className={({ isActive }) =>
                `dashboard-nav-link ${isActive ? "active" : ""}`
              }
            >
              About Quiz
            </NavLink>
          </li>
        </ul>

        {/* Action Buttons */}
        <div className="dashboard-nav-actions">
          <button
            className="dashboard-btn-signin"
            style={{ padding: "6px 10px", fontSize: "13px" }}
            onClick={() => navigate("/")}
          >
            Go Back
          </button>
          <button
            className="dashboard-btn-getstarted"
            style={{ padding: "6px 12px", fontSize: "13px" }}
            onClick={logOut}
          >
            Log Out
          </button>
        </div>
      </div>
      <QuizFaqs />
    </nav>
  );
};

export default Newheader;
